var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarToggle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.41707 9.31004L0.741469 2.63441C0.41951 2.31245 0.41951 1.79047 0.741469 1.46855L1.52007 0.689947C1.84148 0.368538 2.36239 0.36792 2.68456 0.688573L8.00002 5.97913L13.3154 0.688573C13.6376 0.36792 14.1585 0.368538 14.4799 0.689947L15.2585 1.46855C15.5805 1.79051 15.5805 2.31248 15.2585 2.63441L8.58296 9.31004C8.26101 9.63197 7.73903 9.63197 7.41707 9.31004Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarToggle);
export default __webpack_public_path__ + "static/media/sidebar-toggle.03efaf9e10343fb5aaa2a417065d7f29.svg";
export { ForwardRef as ReactComponent };